(function () {
  // Remove render blocker immediately for unsupported browsers
  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
  viewTransitionRenderBlocker?.remove();

  // Exit early if View Transitions API is not supported
  if (!document.startViewTransition || !window.navigation) {
    return;
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = event;
    if (shouldSkipViewTransition(viewTransition)) {
      viewTransition?.skipTransition();
      return;
    }
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(eventName, () => { viewTransition.skipTransition(); }, { once: true });
    });
    document.querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])').forEach((el) => {
      el.removeAttribute('data-view-transition-type');
    });
    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');
    viewTransition.types.clear();
    viewTransition.types.add(transitionType || 'page-navigation');
    if (transitionType) {
      sessionStorage.setItem('custom-transition-type', transitionType);
    } else {
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = event;
    if (shouldSkipViewTransition(viewTransition)) {
      viewTransition?.skipTransition();
      return;
    }
    const customTransitionType = sessionStorage.getItem('custom-transition-type');
    viewTransition.types.clear();
    viewTransition.types.add(customTransitionType || 'page-navigation');
    if (customTransitionType) {
      await viewTransition.finished;
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((el) => {
          el.removeAttribute('data-view-transition-type');
        });
      });
    }
  });

  function shouldSkipViewTransition(viewTransition) {
    return !(viewTransition instanceof ViewTransition) || isLowPowerDevice();
  }

  function isLowPowerDevice() {
    return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  }
})();
